import { CategoriesResponse, Category, CategoryResponse } from "../coworkerApiCalls/Category/CategoriesTypes";

const categoryResponseToCategory = (category: CategoryResponse): Category => {
  return {
    id: category.id,
    title: category.title,
  };
};

const categoryResponsesToCategories = (categories: CategoriesResponse): Category[] => {
  return categories.map((category: CategoryResponse): Category => categoryResponseToCategory(category));
};

export { categoryResponseToCategory, categoryResponsesToCategories };